import Show from '../show'

function UbAdjustmentsDashboard() {
  return (
    <Show
      title="Utility Billing — Adjustments Dashboard"
      dashboardKey="ub_adjustments_dashboards"
      showYear={false}
    />
  )
}

export default UbAdjustmentsDashboard
